import { h, FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { UpliftIcons } from 'up-ops-web-shared-components/lib';
import * as styles from '~src/styles/domains/common/components/Logo.module.scss';
import { FlexpayLogo } from '../assets/svg';
import { Brand } from '../enums/common';
import { brandSelector } from '../state/commonSelectors';

const Logo: FunctionComponent = () => {
  const brand = useSelector(brandSelector);

  return brand == Brand.UPLIFT ? (
    <UpliftIcons.Logo size={88} />
  ) : (
    <span className={styles['flexpay-logo']}>
      <FlexpayLogo />
    </span>
  );
};

export default Logo;
